module.exports = __webpack_public_path__ + "img/bg-forgot-email.0c00bb37.png";